import Vue from 'vue'

const EventBus: Vue = new Vue()

export default EventBus
